import Inputmask from 'inputmask';

export function inputmaskFormat(value, opts, definitions) {
    const previousDef = Inputmask.prototype.definitions;
    Inputmask.prototype.definitions = definitions;

    const result = Inputmask.format(value, opts);
    Inputmask.prototype.definitions = previousDef;

    return result;
}
